import { styled } from "@mui/material/styles";
import Drawer from "@mui/material/Drawer";

export default styled(Drawer)(({ theme, ownerState }) => {
  const { miniSidenav, transparentSidenav, whiteSidenav, darkMode } =
    ownerState || {};

  // Gradient backgrounds matching TopAppBar for full sidebar
  const getBackground = () => {
    if (transparentSidenav) return "transparent";
    if (whiteSidenav) return theme.palette.common.white;
    return darkMode
      ? "linear-gradient(180deg, #1a1a1a 0%, #2d2d2d 100%)"
      : "linear-gradient(180deg, #454545 0%, rgba(90, 90, 90, 0.98) 100%)";
  };

  const getColor = () => {
    if (transparentSidenav) {
      return darkMode ? theme.palette.common.white : theme.palette.common.black;
    }
    if (whiteSidenav) return theme.palette.common.black;
    return theme.palette.common.white;
  };

  const drawerOpenStyles = {
    width: 260,
    background: getBackground(),
    color: getColor(),
    boxShadow: "4px 0 20px rgba(0, 0, 0, 0.15)",
    borderRight: `1px solid ${darkMode ? "rgba(255,255,255,0.08)" : "rgba(255,255,255,0.1)"}`,
    transition: theme.transitions.create("width", {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  };

  const drawerCloseStyles = {
    width: 72,
    background: getBackground(),
    color: getColor(),
    boxShadow: "4px 0 20px rgba(0, 0, 0, 0.15)",
    borderRight: `1px solid ${darkMode ? "rgba(255,255,255,0.08)" : "rgba(255,255,255,0.1)"}`,
    transition: theme.transitions.create("width", {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
  };

  return {
    "& .MuiDrawer-paper": {
      boxSizing: "border-box",
      overflowX: "hidden",
      position: "fixed",
      top: "70px",
      height: "calc(100% - 70px)",
      background: getBackground(),
      ...(miniSidenav ? drawerCloseStyles : drawerOpenStyles),
    },
  };
});
